import React, { useMemo } from 'react';
import { Row, Col, Table, Spinner } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import AgendamentoRow from './AgendamentoRow';

const AgendamentosTable = ({
  agendamentos,
  dateAgenda,
  setDateAgenda,
  codAgenda,
  preencherFormulario,
  handleAtividades,
  setShowReceitaModal,
  handleSelectFaturamento,
  handleAtualizarGuiaContextual,
  isLoading,
}) => {
  const actions = useMemo(
    () => ({
      preencherFormulario,
      handleAtividades,
      setShowReceitaModal,
      handleSelectFaturamento,
      handleAtualizarGuiaContextual,
    }),
    [
      preencherFormulario,
      handleAtividades,
      setShowReceitaModal,
      handleSelectFaturamento,
      handleAtualizarGuiaContextual,
    ]
  );

  return (
    <Row className="m-0 p-0">
      <Col xs={12} sm={2} className="m-0 p-0 mb-3 mb-sm-0">
        <div className="d-flex justify-content-center">
          <DatePicker
            selected={dateAgenda}
            onChange={date => setDateAgenda(date)}
            inline
            locale="ptBR"
            todayButton="Hoje"
            dateFormat="dd/MM/yyyy"
            dropdownMode="select"
            showMonthDropdown
            showYearDropdown
            adjustDateOnChange
          />
        </div>
      </Col>
      <Col xs={12} sm={10} className="m-0 p-0">
        <div className="table-responsive">
          {isLoading ? (
            <div className="text-center" style={{ padding: '3rem' }}>
              <Spinner animation="border" role="status" />
            </div>
          ) : (
            <Table
              bordered="true"
              size="sm"
              variant="primary"
              style={{ fontSize: 10 }}
            >
              <thead>
                <tr>
                  <th>#</th>
                  <th>Horário</th>
                  <th>Paciente</th>
                  <th>Proced</th>
                  <th>Conv</th>
                  <th>Atv</th>
                  <th>Status</th>
                  <th>Celular</th>
                  <th>Obs</th>
                  <th>Confirma</th>
                  <th>Dt/Hora</th>
                  <th>#</th>
                </tr>
              </thead>
              <tbody>
                {agendamentos.map(a => (
                  <AgendamentoRow
                    key={a.CODAGENDA}
                    agenda={a}
                    codAgenda={codAgenda}
                    actions={actions}
                  />
                ))}
              </tbody>
            </Table>
          )}
        </div>
      </Col>
    </Row>
  );
};

export default AgendamentosTable;
